import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import axios from "../utils/axiosConfig";

const AdminDeleteApprovalDialog = ({ show, scope, dealId, fixationIds, onCancel, onApproved }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!show) {
      setUsername("");
      setPassword("");
      setError("");
      setSubmitting(false);
    }
  }, [show]);

  if (!show) return null;

  const submit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    setError("");
    try {
      const response = await axios.post("/auth/fixation-delete-approval", {
        username,
        password,
        scope,
        dealId,
        fixationIds
      });
      setPassword("");
      await onApproved(response.data.approvalToken);
    } catch (requestError) {
      setError(requestError.response?.data?.message || requestError.message || "Administrator approval failed");
    } finally {
      setSubmitting(false);
    }
  };

  return createPortal(
    <div className="modal show d-block" style={{ background: "rgba(0,0,0,0.68)", zIndex: 1080 }} role="dialog" aria-modal="true" aria-labelledby="admin-approval-title">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <form onSubmit={submit}>
            <div className="modal-header">
              <h5 className="modal-title" id="admin-approval-title">Administrator approval required</h5>
              <button type="button" className="btn-close" aria-label="Cancel" onClick={onCancel} disabled={submitting}></button>
            </div>
            <div className="modal-body">
              <p className="mb-3">
                Deleting {fixationIds.length === 1 ? "this fixation" : `${fixationIds.length} fixations`} requires an administrator with Delete permission.
              </p>
              {error && <div className="alert alert-danger py-2" role="alert">{error}</div>}
              <div className="mb-3">
                <label className="form-label" htmlFor="admin-delete-username">Administrator username</label>
                <input
                  id="admin-delete-username"
                  className="form-control"
                  value={username}
                  data-no-uppercase
                  onChange={(event) => setUsername(event.target.value)}
                  autoComplete="username"
                  autoFocus
                  required
                />
              </div>
              <div>
                <label className="form-label" htmlFor="admin-delete-password">Administrator password</label>
                <input
                  id="admin-delete-password"
                  type="password"
                  className="form-control"
                  value={password}
                  data-no-uppercase
                  onChange={(event) => setPassword(event.target.value)}
                  autoComplete="current-password"
                  required
                />
              </div>
              <div className="form-text mt-2">Approval expires after two minutes and applies only to the selected fixation(s).</div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={onCancel} disabled={submitting}>Cancel</button>
              <button type="submit" className="btn btn-danger" disabled={submitting || !username || !password}>
                {submitting ? "Verifying..." : "Approve and delete"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default AdminDeleteApprovalDialog;
